import React from 'react';
import * as S from './References.styles';
import { GlobalOutlined } from '@ant-design/icons';

export const References: React.FC = () => {
  return (
    <S.ReferencesWrapper>
      <S.Text>
        &copy; {new Date().getFullYear()} Kâzım Karabekir Vakfı. Tüm hakları saklıdır.
      </S.Text>
      <S.Icons>
        <a href="https://kazimkarabekirvakfi.org.tr" target="_blank" rel="noreferrer" title="Web Sitesi">
          <GlobalOutlined />
        </a>
      </S.Icons>
    </S.ReferencesWrapper>
  );
};
